import React, { PropsWithChildren, useMemo } from 'react';

import { SelectSearchOptionModel } from '@/components/form/model/SelectSearchOption.model.ts';
import { FullScreenLoader } from '@/components/fullScreenLoader/FullScreenLoader.comp.tsx';
import { useGetUsersShort } from '@/context/dictionariesContext/util/useGetUsersShort.util.ts';

import { DictionariesContext, DictionariesContextProps } from './Dictionaries.context.ts';
import { DictionaryType } from './model/DictionaryType.model.ts';

const DictionariesContextProvider: React.FC<PropsWithChildren> = props => {
  const { isGetting, users } = useGetUsersShort();

  const context: DictionariesContextProps = useMemo(() => {
    return {
      [DictionaryType.USERS]: users
        .map<SelectSearchOptionModel>(it => ({
          label: `${it.firstName} ${it.lastName}`,
          value: it.userId,
        }))
        .sort((a, b) => a.label.localeCompare(b.label)),
    };
  }, [users]);

  if (isGetting) {
    return <FullScreenLoader />;
  }

  return <DictionariesContext value={context}>{props.children}</DictionariesContext>;
};

export default DictionariesContextProvider;
